import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  text: "",
  filters: {}, 
  order: '',
  response: {},
  fullResponse: {},
  searchId: 0,
  origin: '',
  filterOnPress: null
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    searchBooks: (state, action)=>{
      state.text = action.payload;
    },
    responseSearch: (state, action)=>{
      state.response = action.payload;
    },
    preloadFilters:(state, action)=>{
      for(let filter of action.payload){
        state.filters[filter[0]] = filter[1].split('|');
      }
    },
    updateFilters: (state, action)=>{
      let finalElements = action.payload.value.filter((value, index, self) => {
        return self.indexOf(value) === index;
    });
      state.filters[action.payload.section] = finalElements;
    },
    loadMemory: (state, action)=>{
      state.text = action.payload.searchText;
      state.filters = action.payload.filters;
    },
    executeSearch: (state, action)=>{
      if(action.payload){
        state.origin = action.payload;
      }else{
        state.origin = '';
      }
      state.searchId = Math.floor(Math.random() * (999999 - 0) + 0);
    },
    fullResponseSearch: (state, action)=>{
      state.fullResponse = action.payload;
    },
    defineOrder: (state, action)=>{
      state.order = action.payload;
    },
    triggerFilterOnPress: (state)=>{
      state.filterOnPress = (state.filterOnPress === 'CHANGE_UP') ? 'CHANGE_DOWN' : 'CHANGE_UP';
    }
  },
});

export const { 
    searchBooks, 
    responseSearch,
    preloadFilters,
    updateFilters, 
    loadMemory, 
    executeSearch, 
    fullResponseSearch,
    defineOrder,
    triggerFilterOnPress
} = searchSlice.actions;

export default searchSlice.reducer;